import React from 'react';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import useStyles from 'hooks/useStyles';
import { getLiveTopicInfo } from 'reduxModules/live/selector';
import { REGULAR_CLASS_REVIEW_SECTION_CLICK } from 'constants/gtmEvent';
import Button from 'components/Button';
import RatingInfo from 'components/RatingInfo';

import styles from './Overview.scss';

function Overview({ ratingId, lessonId }) {
  useStyles(styles);
  const { t } = useTranslation(['live', 'rating']);

  const {
    contentFeatures,
    detailInfo,
    name,
    frequency,
    scheduleUrl,
    averageRate,
    ratingCount,
  } = useSelector(getLiveTopicInfo);

  const renderFeature = ({ iconUrl, content }, index) => {
    return (
      <li className={styles.feature} key={`${index}-${content}`}>
        <img src={iconUrl} alt={content} className={styles.featureIcon} />
        <p> {content}</p>
      </li>
    );
  };

  const scrollToRating = () => {
    const ratingSection = document.getElementById(ratingId);
    if (ratingSection) ratingSection.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles.root}>
      <h1 className={styles.topicName}>{name}</h1>
      <div className={styles.frequency}>{frequency}</div>
      {ratingCount !== 0 && !lessonId && (
        <RatingInfo
          averageRate={averageRate}
          ratingCount={ratingCount}
          position="OVERVIEW"
          eventName={REGULAR_CLASS_REVIEW_SECTION_CLICK}
          className={styles.ratingInfo}
          onClick={scrollToRating}
        />
      )}
      {scheduleUrl && (
        <div className={cx(styles.schedule)}>
          <div>
            <h4 className={styles.scheduleTitle}>
              {t('live:topic.classScheduleBanner.title')}
            </h4>
            <p className={styles.scheduleDescription}>
              {t('live:topic.classScheduleBanner.description')}
            </p>
          </div>
          <Button
            text={t('live:topic.classScheduleBanner.cta')}
            reversed
            onClick={() => window.open(scheduleUrl)}
          />
        </div>
      )}
      <section className={styles.section}>
        <h2 className={styles.title}>{t('topic.overview.detail.feature')}</h2>

        <ul className={styles.content}>{contentFeatures.map(renderFeature)}</ul>
      </section>
      <section className={styles.section}>
        <h2 className={styles.title}>{t('topic.overview.detail.class')}</h2>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: detailInfo }}
        />
      </section>
    </div>
  );
}

Overview.propTypes = {
  ratingId: string,
  lessonId: string,
};

Overview.defaultProps = {
  ratingId: '',
  lessonId: null,
};

export default Overview;
